import { Control, UseFormResetField, UseFormSetValue, UseFormWatch } from 'react-hook-form'

// local imports
import mapIcon from 'assets/icons/map-full-icon.svg'
import SearchForm from './SearchForm'
import { IMapSearchForm } from '../PageWrapper'
import { BottomInfo, FilterAreaContainer } from '../styled'

interface ISearchFormProps {
  control: Control<IMapSearchForm>
  watch: UseFormWatch<IMapSearchForm>
  resetField: UseFormResetField<IMapSearchForm>
  setValue: UseFormSetValue<IMapSearchForm>
}

export default function FilterArea({ control, resetField, watch, setValue }: ISearchFormProps) {
  return (
    <FilterAreaContainer>
      <SearchForm control={control} resetField={resetField} watch={watch} setValue={setValue} />

      <BottomInfo>
        <img src={mapIcon} className="img-preview" alt="map-icon-full" />

        {/* <div className="info-text">
          <i className="pi pi-info-circle" />
          <div>
            Lorem ipsum dolor sit amet consectetur, adipisicing elit. Sit at earum eiusmi, lacus, commodo auctor
            vulputate
          </div>
        </div> */}
      </BottomInfo>
    </FilterAreaContainer>
  )
}
